import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfTimeInCallsScoreGoalService } from '../../../core/application/services/goals/get-self-time-in-calls-score-goal.service';
import { SelfTimeInCallsScoreGoalEntity } from '../../../core/domain/entities/goals/score-goals/self-time-in-calls-score-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfTimeInCallsScoreGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfTimeInCallsScoreGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfTimeInCallsScoreGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
